export default __webpack_public_path__ + "static/media/OcnAgents_1.55d855a5.svg";